import { useParams } from 'react-router';
import ResponsiveTable from '../../../shared/components/ResponsiveTable';
import {
  FooterColumn,
  SortedColumn,
} from '../../../shared/components/ResponsiveTable/models';
import {
  TableDataProps,
  TotalProductProps,
} from '../../../shared/models/ReportModel';
import CommonColumns from './CommonColumns';
import styles from '../report.module.scss';
import formatCurrency from '../../../shared/utils/formatCurrency';
import {
  getEnrolledNewCountForMembership,
  getEnrolledRenewCountForMembership,
} from '../services';

const getColumns = (dealId: string, reportType: string, isPayByUser: boolean) =>
  [
    ...CommonColumns(dealId, reportType, isPayByUser),
    {
      name: 'Enrolled: New',
      title: 'Redeemed: New',
      cell: (cntx) => (
        <span className="label">
          {getEnrolledNewCountForMembership(cntx.row.original)}
        </span>
      ),
      width: 5,
    },
    {
      name: 'Enrolled: Renew',
      title: 'Redeemed: Renew',
      cell: (cntx) => (
        <span className="label">
          {getEnrolledRenewCountForMembership(cntx.row.original)}
        </span>
      ),
      width: 5,
    },
  ] as SortedColumn[];

const getFooterColumns = (total: TotalProductProps, isPayByUser: boolean) =>
  [
    {
      name: 'Product Name',
      cell: () => <span className={styles.footerCell}>Total</span>,
    },
    {
      name: 'Total Spent',
      cell: () => (
        <span className={styles.footerCell}>{`$${formatCurrency(
          total.totalSpend,
        )}`}</span>
      ),
    },
    !isPayByUser && {
      name: 'Total Quantity',
      cell: () => (
        <span className={styles.footerCell}>{total.quantityTotal}</span>
      ),
    },
    {
      name: 'Available',
      cell: () =>
        isPayByUser ? (
          <span className={styles.footerCell}>&#8734;</span>
        ) : (
          <span className={styles.footerCell}>{total.quantityNotRedeemed}</span>
        ),
    },
    {
      name: 'Redeemed: New',
      cell: () => (
        <span className={styles.footerCell}>{total.statusCounts?.New}</span>
      ),
    },
    {
      name: 'Redeemed: Renew',
      cell: () => (
        <span className={styles.footerCell}>{total.statusCounts?.Renew}</span>
      ),
    },
  ].filter(Boolean) as FooterColumn[]; // Removes the conditional Total Quantity when isPayByUser is true

export default function MembershipTable({
  reportType,
  reportDeals: { overview },
  total,
  isPayByUser,
}: TableDataProps) {
  const { dealId } = useParams();

  return (
    <ResponsiveTable
      data={overview.memberships}
      columns={getColumns(dealId, reportType, isPayByUser)}
      footerColumns={getFooterColumns(total, isPayByUser)}
    />
  );
}
